/*
 * Broadcast Theme - Custom JS
 * Keep all your customizations here so updating Broadcast is easier.
 */
(function() {
  // === RECENTLY VIEWED PRODUCTS (Product Page Only) ===
  (function() {
    if (!document.querySelector('.template-product')) return;

    const getProductHandle = () => {
      const path = window.location.pathname;
      if (path.includes('/products/')) {
        return path.split('/products/')[1].split('?')[0].split('#')[0];
      }
      return '';
    };

    const setCookie = (name, value, days) => {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value || ""}; expires=${date.toUTCString()}; path=/`;
    };

    const getCookie = (name) => {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(';');
      for (let c of ca) {
        c = c.trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
      }
      return null;
    };

    const currentHandle = getProductHandle();
    if (!currentHandle) return;

    const recentlyViewed = getCookie('recently_viewed')
      ? JSON.parse(getCookie('recently_viewed'))
      : [];

    const updatedRecentlyViewed = recentlyViewed.filter(h => h !== currentHandle);
    updatedRecentlyViewed.unshift(currentHandle);
    const limitedRecentlyViewed = updatedRecentlyViewed.slice(0, 10);

    setCookie('recently_viewed', JSON.stringify(limitedRecentlyViewed), 30);
  })();


  // === RECENT SEARCHES (Predictive Search + Autocomplete) ===
  function saveRecentSearch(searchTerm) {
    if (!searchTerm || !searchTerm.trim()) return;

    let recentSearches = getRecentSearches();
    recentSearches = recentSearches.filter(term => term.toLowerCase() !== searchTerm.toLowerCase());
    recentSearches.unshift(searchTerm.trim());
    recentSearches = recentSearches.slice(0, 5);

    document.cookie = `recent_searches=${JSON.stringify(recentSearches)}; path=/; max-age=${60 * 60 * 24 * 30}`;
  }

  function getRecentSearches() {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'recent_searches') {
        try {
          return JSON.parse(decodeURIComponent(value));
        } catch {
          return [];
        }
      }
    }
    return [];
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Save submitted searches
    document.querySelectorAll('form[action*="search"]').forEach(form => {
      form.addEventListener('submit', function() {
        const input = form.querySelector('input[name="q"]');
        if (input?.value) saveRecentSearch(input.value);
      });
    });

    // === Predictive Search Observer & Autocomplete Logic ===
    let populateTimeout;
    let isPopulating = false;

    function populateRecentSearches() {
      if (isPopulating) return;
      isPopulating = true;

      const recentSearches = getRecentSearches();
      const container = document.querySelector('.predictive-search__recent-searches');
      const list = document.querySelector('.predictive-search__recent-searches-list');

      if (!container || !list) {
        isPopulating = false;
        return;
      }

      if (recentSearches.length > 0) {
        list.innerHTML = '';
        recentSearches.forEach((term, i) => {
          const item = document.createElement('div');
          item.className = 'predictive-search__item';
          item.id = `predictive-search-option-recent-${i + 1}`;
          item.role = 'option';
          item.setAttribute('aria-selected', 'false');

          const link = document.createElement('a');
          link.className = 'predictive-search__link';
          link.href = `/search?q=${encodeURIComponent(term)}`;
          link.tabIndex = -1;
          link.textContent = term;

          item.appendChild(link);
          list.appendChild(item);
        });
        container.style.display = 'block';
      } else {
        container.style.display = 'none';
      }
      isPopulating = false;
    }

    function debouncedPopulateRecentSearches() {
      clearTimeout(populateTimeout);
      populateTimeout = setTimeout(populateRecentSearches, 150);
    }

    const observer = new MutationObserver(mutations => {
      let shouldPopulate = false;
      let shouldTryAutoComplete = false;

      mutations.forEach(m => {
        if (m.type === 'childList') {
          const added = Array.from(m.addedNodes);
          const hasResults = added.some(node =>
            node.nodeType === 1 &&
            (node.id === 'predictive-search-results' ||
             node.querySelector?.('#predictive-search-results'))
          );
          if (hasResults) {
            shouldPopulate = true;
            shouldTryAutoComplete = true;
          }

          const hasLinks = added.some(node =>
            node.nodeType === 1 &&
            (node.classList?.contains('predictive-search__link') ||
             node.querySelector?.('.predictive-search__link'))
          );
          if (hasLinks) shouldTryAutoComplete = true;
        }
      });

      if (shouldPopulate) debouncedPopulateRecentSearches();
      if (shouldTryAutoComplete && activeInput) {
        setTimeout(() => tryAutoComplete(), 50);
      }
    });

    const searchContainer =
      document.querySelector('[data-predictive-search]') ||
      document.querySelector('.search-modal') ||
      document.body;
    observer.observe(searchContainer, { childList: true, subtree: true });

    // === Autocomplete ===
    let currentAutoComplete = '';
    let autoCompleteTimeout;
    let lastInputValue = '';
    let activeInput = null;

    function findBestMatch(value) {
      if (!value || value.length < 2) return null;
      const suggestions = [];
      document.querySelectorAll('.predictive-search__link').forEach(link => {
        const text = link.textContent.trim();
        if (text.toLowerCase().startsWith(value.toLowerCase())) suggestions.push(text);
      });
      getRecentSearches().forEach(term => {
        if (term.toLowerCase().startsWith(value.toLowerCase()) && !suggestions.includes(term)) {
          suggestions.push(term);
        }
      });
      return suggestions[0] || null;
    }

    function tryAutoComplete(value = null) {
      if (!activeInput) return;
      const currentValue = value || activeInput.value;
      if (currentValue.length < 2) {
        hideAutoComplete(activeInput);
        return;
      }
      const match = findBestMatch(currentValue);
      if (match) showAutoComplete(activeInput, match);
      else hideAutoComplete(activeInput);
    }

    function showAutoComplete(input, suggestion) {
      const value = input.value;
      if (!suggestion.toLowerCase().startsWith(value.toLowerCase())) return;
      const completion = suggestion.substring(value.length);
      currentAutoComplete = suggestion;

      let span = input.parentElement.querySelector('.search-autocomplete');
      if (!span) {
        span = document.createElement('span');
        span.className = 'search-autocomplete';
        span.style.cssText = `
          position:absolute;color:#fff;pointer-events:none;font-family:inherit;
          font-size:13px;font-weight:700;white-space:pre;z-index:1;
          background:#000;font-style:italic;text-transform:lowercase;
        `;
        if (getComputedStyle(input.parentElement).position === 'static') {
          input.parentElement.style.position = 'relative';
        }
        input.parentElement.appendChild(span);
      }

      const measure = document.createElement('span');
      const styles = getComputedStyle(input);
      measure.style.cssText = `
        position:absolute;visibility:hidden;white-space:pre;
        font-family:${styles.fontFamily};
        font-size:${styles.fontSize};
        font-weight:${styles.fontWeight};
        letter-spacing:${styles.letterSpacing};
        word-spacing:${styles.wordSpacing};
      `;
      measure.textContent = value;
      document.body.appendChild(measure);
      const textWidth = measure.offsetWidth;
      document.body.removeChild(measure);

      span.style.left = `${parseInt(styles.paddingLeft) + textWidth}px`;
      span.style.top = `${parseInt(styles.paddingTop)}px`;
      span.textContent = completion;
    }

    function hideAutoComplete(input) {
      input.parentElement.querySelector('.search-autocomplete')?.remove();
      currentAutoComplete = '';
    }

    document.querySelectorAll('input[name="q"], input[type="search"]').forEach(input => {
      input.addEventListener('focus', function() {
        activeInput = this;
        debouncedPopulateRecentSearches();
      });
      input.addEventListener('input', function() {
        clearTimeout(autoCompleteTimeout);
        activeInput = this;
        lastInputValue = this.value;
        if (this.value.length < 2) {
          hideAutoComplete(this);
          return;
        }
        const match = findBestMatch(this.value);
        if (match) showAutoComplete(this, match);
        else {
          hideAutoComplete(this);
          autoCompleteTimeout = setTimeout(() => {
            if (this.value === lastInputValue && activeInput === this) {
              tryAutoComplete(lastInputValue);
            }
          }, 300);
        }
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Tab' && currentAutoComplete) {
          e.preventDefault();
          this.value = currentAutoComplete;
          hideAutoComplete(this);
          this.dispatchEvent(new Event('input', { bubbles: true }));
        } else if (e.key === 'Escape') {
          hideAutoComplete(this);
        }
      });
      input.addEventListener('blur', function() {
        setTimeout(() => {
          hideAutoComplete(this);
          if (activeInput === this) activeInput = null;
        }, 150);
      });
    });

    if (document.readyState === 'complete') debouncedPopulateRecentSearches();
    else window.addEventListener('load', debouncedPopulateRecentSearches, { once: true });
  });


  // === RECENT SEARCHES (Recent Search Div) ===
  (function() {
    function populateRecentSearches() {
      const recentSearches = getRecentSearches();
      const wrappers = document.querySelectorAll('.recent_search__wrap');
      const containers = document.querySelectorAll('.recent_search');
      const highlights = document.querySelectorAll('.wrapper.highlights');
      if (!containers.length) return;

      const isSearchPage = document.body.classList.contains('template-search')
        || window.location.pathname.includes('/search')
        || document.querySelector('.search-page');
      const noResultsDiv = document.querySelector('.no-results');
      const searchInputValue = document.querySelector('input[name="q"]')?.value.trim() || '';

      const shouldShow = recentSearches.length > 0 &&
        (!isSearchPage || searchInputValue === '' || noResultsDiv);

      containers.forEach(container => {
        container.innerHTML = '';
        recentSearches.forEach((term, idx) => {
          const link = document.createElement('a');
          link.href = `/search?q=${encodeURIComponent(term)}`;
          link.textContent = term;
          link.addEventListener('click', function(e) {
            e.preventDefault();
            const input = document.querySelector('input[name="q"]');
            if (input) {
              input.value = term;
              input.closest('form')?.submit();
            }
          });
          container.appendChild(link);
          if (idx < recentSearches.length - 1) {
            const sep = document.createElement('sep');
            sep.textContent = '/';
            container.appendChild(sep);
          }
        });
      });

      wrappers.forEach(w => w.style.display = shouldShow ? 'flex' : 'none');
      highlights.forEach(h => h.style.display = shouldShow ? 'block' : 'none');
    }

    function initializeRecentSearches() {
      populateRecentSearches();
      document.querySelectorAll('input[name="q"], input[type="search"]').forEach(input => {
        input.addEventListener('input', function() {
          if (this.value.trim().length > 0) {
            document.querySelectorAll('.recent_search__wrap, .wrapper.highlights').forEach(el => el.style.display = 'none');
          } else {
            populateRecentSearches();
          }
        });
      });
    }

    initializeRecentSearches();
    document.addEventListener('DOMContentLoaded', () => setTimeout(initializeRecentSearches, 100));
    window.addEventListener('load', () => setTimeout(populateRecentSearches, 200));
  })();


  // === DISABLE AUTOCOMPLETE ON SEARCH PAGE ===
  (function() {
    function disableSearchFormAutocomplete() {
      document.querySelectorAll('.search-page .search-form').forEach(form => {
        form.setAttribute('autocomplete', 'off');
        form.setAttribute('spellcheck', 'false');
        form.querySelectorAll('input[type="search"], input[name="q"]').forEach(input => {
          input.setAttribute('autocomplete', 'off');
          input.setAttribute('autocapitalize', 'off');
          input.setAttribute('autocorrect', 'off');
          input.setAttribute('spellcheck', 'false');
        });
      });
    }
    document.addEventListener('DOMContentLoaded', disableSearchFormAutocomplete);
    window.addEventListener('load', disableSearchFormAutocomplete);
  })();


  // === SAVE DIRECT SEARCH QUERIES ===
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      const q = new URLSearchParams(window.location.search).get('q');
      if (q?.trim()) saveRecentSearch(q);
    });
  })();


  // === REDIRECT .product-view-link ===
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.product-view-link').forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const url = link.getAttribute('data-current-product-url') || link.href;
          if (url) window.location.href = url;
        });
      });
    });
  })();


  // === CART DRAWER: Upsell Slider & Free Shipping ===
  (function() {
    function initCartUpsellSlider() {
      const upsellCarousels = document.querySelectorAll('.cart__upsell-carousel');
      if (typeof Swiper === 'undefined' || !upsellCarousels.length) return;

      upsellCarousels.forEach(carousel => {
        if (carousel.classList.contains('swiper-initialized')) return;

        carousel.classList.add('swiper');
        carousel.querySelectorAll('.cart-upsell-item').forEach(slide => slide.classList.add('swiper-slide'));

        if (!carousel.querySelector('.swiper-wrapper')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'swiper-wrapper';
          while (carousel.firstChild) wrapper.appendChild(carousel.firstChild);
          carousel.appendChild(wrapper);
        }

        if (!carousel.querySelector('.swiper-button-next')) {
          carousel.insertAdjacentHTML('beforeend', '<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>');
        }

        carousel.__swiper = new Swiper(carousel, {
          slidesPerView: 2,
          spaceBetween: 12,
          navigation: {
            nextEl: carousel.querySelector('.swiper-button-next'),
            prevEl: carousel.querySelector('.swiper-button-prev'),
          },
          loop: carousel.querySelectorAll('.cart-upsell-item').length > 2,
          observer: true,
          observeParents: true,
          breakpoints: {
            0: { slidesPerView: 1 },
            400: { slidesPerView: 2 }
          }
        });

        carousel.classList.add('swiper-initialized');
      });
    }

    function updateFreeShippingBar() {
      const freeShipping = document.querySelector('.cart-drawer .free-shipping');
      if (!freeShipping) return;
      const progressBar = freeShipping.querySelector('[data-progress-bar]');
      const subtotalEl = document.querySelector('.cart__total__price[data-cart-total]');
      if (!progressBar || !subtotalEl) return;

      const limit = parseFloat(freeShipping.getAttribute('data-free-shipping-limit'));
      let subtotal = parseFloat(subtotalEl.getAttribute('data-cart-total')) / 100;
      if (!limit || isNaN(subtotal)) return;

      const percent = Math.min(100, Math.round((subtotal / limit) * 100));
      progressBar.value = percent;
      subtotal >= limit
        ? freeShipping.classList.add('is-success')
        : freeShipping.classList.remove('is-success');
    }

    function onCartDrawerUpdate() {
      setTimeout(() => {
        initCartUpsellSlider();
        updateFreeShippingBar();
      }, 300);
    }

    document.addEventListener('cart:updated', onCartDrawerUpdate);
    document.addEventListener('cart:drawer:opened', onCartDrawerUpdate);
    document.addEventListener('DOMContentLoaded', onCartDrawerUpdate);
  })();


  // === STORAGE & CACHE CLEAR (Run once on live site) ===
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  function deleteAllCookies() {
    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    });
  }

  function clearAllStorageAndCache() {
    deleteAllCookies();
    localStorage.clear();
    sessionStorage.clear();
    if ('caches' in window) {
      caches.keys().then(names => names.forEach(name => caches.delete(name)));
    }
  }

  // Prevent infinite reload inside Shopify Theme Editor
  if ((typeof Shopify === 'undefined' || !Shopify.designMode) && !getCookie("cookie_dump")) {
    clearAllStorageAndCache();
    setCookie("cookie_dump", "success", 365);
    window.location.reload();
  }

})();
